import ZendeskIconHideWrapper from "@stadium/services/zendesk/icon-hide-wrapper";
import HideHubspotFeedbackForm from "@stadium/services/hubspot/hide-hubspot-feedback-form";

const BottomIconHideWrapper = ({ children, hideIcon = true }) => {
  return (
    <ZendeskIconHideWrapper hideIcon={hideIcon}>
      <HideHubspotFeedbackForm hideIcon={hideIcon}>{children}</HideHubspotFeedbackForm>
    </ZendeskIconHideWrapper>
  );
};

export default BottomIconHideWrapper;
